import React, { Component } from 'react'
import ProjectList from './ProjectList'

class Portfolio extends Component {
  render(){
    return(
      <ProjectList />
    );
  }
}

export default Portfolio



/** WEBPACK FOOTER **
 ** ./src/Portfolio.js
 **/